import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

const AdminPageEditHeader = ({ pageId }) => {
  const intl = useIntl();

  return (
    <header className="page-header">
      <h2 className="page-title">
        <i className="far fa-table-layout" />
        {
          pageId ?
            intl.formatMessage({ defaultMessage: 'Edit Content Portal' }) :
            intl.formatMessage({ defaultMessage: 'New Content Portal' })
        }
      </h2>
    </header>
  );
};

AdminPageEditHeader.propTypes = {
  pageId: PropTypes.string,
};

AdminPageEditHeader.defaultProps = {
  pageId: null,
};

export default AdminPageEditHeader;
